// One chart of Redis's history (System overview): a panel and a range; the server names the queries.
import { useQuery } from '@tanstack/react-query';
import { getSystemRedisSeriesOptions } from '../../../generated/api/@tanstack/react-query.gen.js';
import type { GetSystemRedisSeriesData } from '../../../generated/api/types.gen.js';
import type { MetricRange } from './metric-format.js';
import { refreshFor } from './RangePills.js';
import { SeriesChartCard } from './SeriesChartCard.js';

type RedisPanel = GetSystemRedisSeriesData['query']['panel'];

interface RedisMetricChartProps {
  panel: RedisPanel;
  range: MetricRange;
  title: string;
  description?: string;
}

export function RedisMetricChart({ panel, range, title, description }: RedisMetricChartProps) {
  const query = useQuery({
    ...getSystemRedisSeriesOptions({ query: { panel, range } }),
    refetchInterval: refreshFor(range),
  });
  return (
    <SeriesChartCard
      title={title}
      description={description}
      range={range}
      data={query.data}
      loading={query.isPending}
      error={query.error}
    />
  );
}
